module.exports = __webpack_public_path__ + "../resources/images/Promos-9273fdfce3fb9c3ae33cce8d7af0e64d.svg";